import * as React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { connect } from 'react-redux'
import '../../../App.css'
import '../../../css/modal.scss'
import TopSection from './TopSection'
import MiddleSection from './MiddleSection'
import BottomSection from './BottomSection'
import { paymentModes, paymentModesWithAll } from '../../common/paymentsMode'
import Dashboard from '../../common/DashBoard'
import { getDashBoardData, getDriverList, getVehicleList, updateAlert } from '../../../store/common/common_action'
import { isEmpty } from '../../common/helper'
import { alertAtom, globalLoaderAtom } from '../../common/jotaiState/globalStateAtoms'
import { useSetAtom } from 'jotai'
import { urls } from '../../common/constants'
import { GetRequest } from '../../common/api'

const BranchTransfer = ({ data, getDriverList, getVehicleList, updateAlert, getDashBoardData }) => {
  const { common } = data
  const { strtCity, strtBrnch, cityList, destBrnchList, cnsgnmntTypes, loader, loginData, alert, dispatchDashboard } = { ...common }
  const [dashboardOpen, setDashboardOpen] = useState(true)
  const setLoader = useSetAtom(globalLoaderAtom)
  const {intCompanyID,intBranchCityID,intBranchID,intUserID} = loginData
  const setAlert = useSetAtom(alertAtom)
  const [cityListData, setCityListData] = useState([])
  const [branchListData, setBranchListData] = useState([])
  const [active, setActive] = useState(1)
  const [state, setState] = useState({
    showListTable: false,
    showListAllTable: false,
    defaultValueForTop: false,
  })
  const [allSelected, setAllselected] = useState({
    selectDestCity: 'All',
    selectDestBranch: 'All',
    selectBookingtype: 'All',
    selectconsignmentType: 'All',
    selectedButtonType: 'Booking',
  })
  const [allDataTopSection, setAllDataTopsection] = useState({
    transferFromCity: null,
    transferFromBranch: null,
    SelectDestCity: [],
    SelectDestBranch: [],
    BookingType: null,
    consignTypes: null,
  })
  const [selectedData, setSelectedData] = useState([])
  const { showListTable, showListAllTable } = state
  const testInp = React.useRef(null)
  const testInp1 = React.useRef(null)
  const [cancelEdit, setCancelEdit] = useState(false)
  const [cancelEditData, setCancelEditData] = useState()
  const handleAlert = (msg = false) => {
    if (!(msg instanceof Event)) {
      if (msg) {
        updateAlert({ show: true, msg })
      } else {
        updateAlert({ show: false, msg: '' })
      }
    }
  }
  const fetchDestCityBranchData = async () => {
    if (!intCompanyID || !intBranchID || !intBranchCityID) return
    setLoader(true)
    const data = {
      intCompanyID,
      intBranchID,
      intCityID: intBranchCityID,
      intLoginUserID: intUserID,
      intMode: active,
      IsFromTo: 0,
    }
    try {
      const res = await GetRequest(urls.getBranchTransferCities, data)
      if (res.status !== 'Success') {
        throw new Error(res?.ErrMessage || 'Request Failed')
      }
      const table = res?.Data?.Table || []
      if (!table.length) throw new Error('No Data Found')
      const cityData = Array.from(
        new Map(table.map(item => [item.CityID, {
          CityID: item.CityID,
          CityName: item.CityName,
        }])).values()
      )
      const branchData = Array.from(
        new Map(table.map(item => [item.BranchID, {
          BranchID: item.BranchID,
          BranchName: item.BranchName,
          CityID: item.CityID,
        }])).values()
      )
      setCityListData(cityData)
      setBranchListData(branchData)
    } catch (err) {
      setAlert({ show: true, msg: err.message, nextId: '' })
    } finally {
      setLoader(false)
    }
  }
  useEffect(() => {
  if (intCompanyID && intBranchID && intBranchCityID) {
    fetchDestCityBranchData()
  }
}, [intCompanyID, intBranchID, intBranchCityID, active])
  useEffect(() => {
    setState({ ...state, showListTable: false, showListAllTable: false })
    setSelectedData([])
  }, [allSelected])
  useEffect(() => {
    const destCityes = cityListData.filter(({ CityID }) => strtCity?.CityID != CityID)

    setAllDataTopsection({
      ...allDataTopSection,
      transferFromCity: strtCity?.CityName,
      transferFromBranch: strtBrnch?.BranchName,
      SelectDestCity: destCityes,
      SelectDestBranch: branchListData,
      BookingType: paymentModesWithAll,
      consignTypes: cnsgnmntTypes,
    })
  }, [strtCity, cityListData, strtBrnch, branchListData])
  useEffect(() => {
    setState({ ...state, defaultValueForTop: false })
  }, [])
  useEffect(() => {
    if (!isEmpty(loginData)) {
      getVehicleList(loginData, true, 24 * 60 * 60 * 1000)
      getDriverList(loginData, true, 24 * 60 * 60 * 1000)
      getDashBoardData(loginData, 'D')
    }
  }, [loginData])
  return (
    <>
      <TopSection
        buttonId="bkbutton"
        setState={setState}
        selelectedData={allSelected}
        allDataTopSection={allDataTopSection}
        setSelectedData={setAllselected}
        defaultValueForTop={state.defaultValueForTop}
        cancelEdit={cancelEdit}
        selectedLRS={setSelectedData}
        setActive={setActive}
      />
      {dashboardOpen && showListTable === false ? (
        <Dashboard setDashboardOpen={setDashboardOpen} Type="BranchTransfer" DashboardData={dispatchDashboard} handleAlert={handleAlert} />
      ) : (
        ''
      )}

      {showListTable ? (
        <MiddleSection
          details={allSelected}
          inputCheck={state.showListAllTable}
          selelectedData={selectedData}
          setSelectedData={setSelectedData}
          cancelEdit={cancelEdit}
          cancelEditData={cancelEditData}
        />
      ) : (
        ''
      )}

      <BottomSection
        selelectedData={selectedData}
        setSelectedData={setSelectedData}
        allSelected={allSelected}
        allState={state}
        setAllState={setState}
        allDataTopSection={allSelected}
        setAllDataTopsection={setAllselected}
        destinationCityOp={allDataTopSection.SelectDestCity}
        cancelEdit={cancelEdit}
        setCancelEdit={setCancelEdit}
        setCancelEditData={setCancelEditData}
        cancelEditData={cancelEditData}
        handleAlert={handleAlert}
        inputCheck={state.showListAllTable}

      />
    </>
  )
}

const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = {
  getVehicleList,
  getDriverList,
  updateAlert,
  getDashBoardData,
}

export default connect(mapStateToProps, mapDispatchToProps)(BranchTransfer)
